module.exports = __webpack_public_path__ + "static/img/ceshi3.5570dfd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/ceshi3.jpeg
// module id = 8kgn
// module chunks = 1